import gql from 'graphql-tag';

const query = gql`
  query deliveryTreatmentMethod {
    diabetes {
      userDiabetes {
        treatment {
          insulinDeliveryMethod
          insulinCorrectionFactor
          insulinToCarbRatios {
            mealType
            mealTypeEnum
            ratio
          }
          bloodSugarUnit
        }
      }
    }
  }
`;

export default query;
